export const UserNoteCategories = {
	TRADING: 1,
	PROMOTION: 2,
	BETTING: 3,
	CLIENT_MANAGER: 4
};

export const UserNoteCategoryNames = {
	[UserNoteCategories.TRADING]: 'Trading',
	[UserNoteCategories.PROMOTION]: 'Promotion/Bonus',
	[UserNoteCategories.BETTING]: 'Betting',
	[UserNoteCategories.CLIENT_MANAGER]: 'Client Manager'
};
